import Yup from '../../../../utils/yup';
import { rucValidator } from '../../../Validations';

export function validationFunctionEducationLevel(values) {
  const errors = {};
  // Custom Validations
  return errors;
}

export const validationSchemaEducationLevel = Yup.object().shape({
  name: Yup.string().required(),
});
